import { transliterateCyrillic } from '../../../../utils/utm/transliterateCyrillic'

/**
 * Ukrainian name → latin slug with hyphens (not underscores).
 * Does not auto-run on name edit after save — caller decides when to generate.
 */
export function slugifyCatalogTaxonomyName(value = '') {
  const transliterated = transliterateCyrillic(String(value))
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

  return transliterated
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-')
}

export function isValidCatalogTaxonomySlug(slug) {
  if (typeof slug !== 'string' || !slug) return false
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug)
}

/**
 * Sibling uniqueness includes archived nodes (slug stays reserved).
 * @param {string} slug
 * @param {Array<{ id?: string, slug?: string }>} siblings
 * @param {string} [excludeNodeId]
 */
export function isCatalogTaxonomySlugTaken(slug, siblings = [], excludeNodeId = '') {
  const normalized = String(slug || '')
  if (!normalized) return false

  return siblings.some((node) => {
    if (excludeNodeId && `${node.id}` === `${excludeNodeId}`) return false
    return node.slug === normalized
  })
}
